import { Button } from '@progress/kendo-react-buttons'
import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import * as Actions from '../actions'
import * as Utils from '../utils'

export class DeleteCell extends GridCell {

  public render() {
    return <td className="edit">
      {Utils.canDelete(this.props.dataItem) ?
      <Button icon="delete" primary={true} onClick={this.deleteRow.bind(this)}/>
      : <span></span>}
    </td>
  }
  private deleteRow = () =>
    this.props.dataItem.dispatch(Actions.deleteHoliday(this.props.dataItem))

}



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/render/delete_cell.tsx